import { ReactNode } from 'react'

import { LeadProvider, LeadState } from 'modules/lead/context'
import { TransmissionProvider, TransmissionState } from 'modules/transmission/context'
import { ThemeProvider, ThemeState } from 'common/context/theme'
import { ChatProvider, ChatState } from 'modules/chat/context'
import { AuthProvider } from 'modules/auth/context'

export interface ProvidersState {
  theme?: ThemeState,
  transmission?: TransmissionState,
  lead?: LeadState,
  chat?: ChatState
}

export interface Props {
  children: ReactNode,
  state?: ProvidersState
}

const Providers = ({ children, state }: Props) => {
  return (
    <ThemeProvider state={state?.theme}>
      <AuthProvider>
        <LeadProvider state={state?.lead}>
          <TransmissionProvider state={state?.transmission}>
            <ChatProvider state={state?.chat}>
              {children}
            </ChatProvider>
          </TransmissionProvider>
        </LeadProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default Providers
